import { DeviceCamera, EventBase } from "@vp/models";
export interface DeviceCamerasNotificationEventArgs {
  deviceUserId: string;
  deviceCameras: DeviceCamera[];
}

export class DeviceCamerasUpdatedEvent extends EventBase<DeviceCamerasNotificationEventArgs> {
  constructor(notification: DeviceCamerasNotificationEventArgs) {
    super();
    this.args = notification;
  }
}
